import TButton from './t-button.vue'
import TInput from './form/t-input.vue'

export default [
  TButton, TInput,
]
